import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, Lock } from "lucide-react";
import "./Footer.scss";
import companyLogo from "../media/logos/logo-color.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* Brand column */}
        <div className="footer-brand">
          <img src={companyLogo} alt="El Gouna Sailing Club" className="footer-logo" />
          <span className="footer-club-name">El Gouna Sailing Club</span>
          <p className="footer-tagline">A sailing &amp; boat charter experience on the Red Sea.</p>
        </div>

        {/* Contact column */}
        <div className="footer-contact">
          <h4 className="footer-col-heading">Contact</h4>
          <a href="mailto:info@gounasailingclub.com" className="footer-link">
            <Mail size={16} strokeWidth={2} />
            info@gounasailingclub.com
          </a>
          <a href="tel:+201224524055" className="footer-link">
            <Phone size={16} strokeWidth={2} />
            +20 122 452 4055
          </a>
          <a
            href="https://wa.me/201224524055"
            className="footer-link footer-link--whatsapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-whatsapp"></i>
            WhatsApp Us
          </a>
        </div>

        {/* Social column */}
        <div className="footer-social-col">
          <h4 className="footer-col-heading">Follow Us</h4>
          <div className="footer-social-links">
            <a
              href="https://www.instagram.com/elgounasailingclub?igsh=MWNyYThpbzl0d3VhZQ%3D%3D&utm_source=qr"
              className="footer-social-btn"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i className="fa-brands fa-instagram"></i>
              Instagram
            </a>
            <a
              href="https://www.facebook.com/share/5rWkrPpanencuja8/?mibextid=LQQJ4d"
              className="footer-social-btn"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="fa-brands fa-facebook-f"></i>
              Facebook
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} El Gouna Sailing Club. All rights reserved.</p>
        <Link to="/admin" className="footer-login-btn">
          <Lock size={12} strokeWidth={2} /> Admin Login
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
